import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createHocName from '../services/create-hoc-name';
import { isMobile } from '../services/wix-sdk-utils';

const NAME = 'WithDeviceType';

export default function withDeviceType(WrappedComponent) {
  class WithDeviceType extends Component {
    static displayName = createHocName(NAME, WrappedComponent);

    render() {
      const isMobileVal = isMobile();
      return <WrappedComponent isMobile={isMobileVal} isDesktop={!isMobileVal} {...this.props}/>;
    }
  }

  hoistNonReactStatics(WithDeviceType, WrappedComponent);

  return WithDeviceType;
}



// WEBPACK FOOTER //
// ./app/hoc/with-device-type.js